<ada-card
	#RelationshipsPropertiesCard
	id="RelationshipsPropertiesCard"
	verticalSpacing="Small"
	width="100%"
	[collapseEnabled]="true"
>
	<ada-text
		content="Relationships Properties"
		data-container-selector="ada-card-header"
		id="RelationshipsPropertiesCardHeader"
	/>
	<ada-container
		data-container-selector="ada-card-body"
		horizontalSpacing="Medium"
		verticalSpacing="Medium"
		[colCount]="4"
		[padding]="defaultCardPadding"
	>
		<!-- PrerequisiteInstallTree -->
		@if ('PrerequisiteInstallTree' | displayAuthoringProperty: editorClass : propertyConstructor.namespace) {
			<ada-authoring-property-label
				#PrerequisiteInstallTreeLabel
				content="Prerequisite Install Tree"
				id="PrerequisiteInstallTreeLabel"
				[inheriting]="currentPropertyObject?.PrerequisiteInstallTree | inheritPipe: inheritedPropertyObject?.PrerequisiteInstallTree"
				[isDisabled]="isDisabled"
				[isRequired]="'PrerequisiteInstallTree' | isRequiredProperty: editorClass : propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('PrerequisiteInstallTree'); PrerequisiteInstallTree.setValue(null)"
			/>
			<ada-container [responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG">
				<ada-prerequisite-tree
					#PrerequisiteInstallTree
					data-testid="relationships-prerequisite-install-tree"
					[isDisabled]="isDisabled"
					[metadataObject]="serverObject$ | async"
					[value]="
						currentPropertyObject?.PrerequisiteInstallTree !== undefined
							? currentPropertyObject.PrerequisiteInstallTree
							: inheritedPropertyObject?.PrerequisiteInstallTree
					"
					(valueChange)="setObjectPropertyValue('PrerequisiteInstallTree', $event)"
				/>
			</ada-container>
		}
		<!-- FollowupInstallTree -->
		@if ('FollowupInstallTree' | displayAuthoringProperty: editorClass : propertyConstructor.namespace) {
			<ada-authoring-property-label
				#FollowupInstallTreeLabel
				content="Followup Install Tree"
				id="FollowupInstallTreeLabel"
				[inheriting]="currentPropertyObject?.FollowupInstallTree | inheritPipe: inheritedPropertyObject?.FollowupInstallTree"
				[isDisabled]="isDisabled"
				[isRequired]="'FollowupInstallTree' | isRequiredProperty: editorClass : propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('FollowupInstallTree'); FollowupInstallTree.setValue(null)"
			/>
			<ada-container [responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG">
				<ada-prerequisite-tree
					#FollowupInstallTree
					data-testid="relationships-followup-install-tree"
					[isDisabled]="isDisabled"
					[metadataObject]="serverObject$ | async"
					[value]="
						currentPropertyObject?.FollowupInstallTree !== undefined
							? currentPropertyObject.FollowupInstallTree
							: inheritedPropertyObject?.FollowupInstallTree
					"
					(valueChange)="setObjectPropertyValue('FollowupInstallTree', $event)"
				/>
			</ada-container>
		}
		<!-- TODO: put this back once 9.1.965 has been in GA long enough that we can support production rollout of PrerequisiteInstallTree -->
		<!-- <ng-container *ngIf="('PrerequisiteInstalls' | displayAuthoringProperty: editorClass:propertyConstructor.namespace) &&
			(currentPropertyObject?.PrerequisiteInstalls || inheritedPropertyObject?.PrerequisiteInstalls)?.length > 0"> -->

		<!-- PrerequisiteInstalls -->
		@if ('PrerequisiteInstalls' | displayAuthoringProperty: editorClass : propertyConstructor.namespace) {
			<ada-authoring-property-label
				#PrerequisiteInstallsLabel
				content="Prerequisite Installs"
				id="PrerequisiteInstallsLabel"
				[inheriting]="currentPropertyObject?.PrerequisiteInstalls | inheritPipe: inheritedPropertyObject?.PrerequisiteInstalls"
				[isDisabled]="isDisabled"
				[isRequired]="'PrerequisiteInstalls' | isRequiredProperty: editorClass : propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('PrerequisiteInstalls')"
			/>
			<ada-container
				verticalSpacing="small"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<!-- @if (currentPropertyObject?.PrerequisiteInstallTree || inheritedPropertyObject?.PrerequisiteInstallTree) {
					<ada-alert
						type="warning"
						[isClosable]="false"
						[title]="'Ignored in favor of PrerequisiteInstallTree'"
					/>
				} -->
				<ada-object-list
					#PrerequisiteInstallsInput
					buttonText="Add Prerequisite Installs"
					data-testid="relationships-properties-prerequisite-install-list"
					id="PrerequisiteInstallsInput"
					[isDisabled]="isDisabled"
					[isReadOnly]="!!(currentPropertyObject?.PrerequisiteInstallTree || inheritedPropertyObject?.PrerequisiteInstallTree)"
					[javaClassName]="relationshipsClassName"
					[objectIds]="currentPropertyObject?.PrerequisiteInstalls"
					[staticFilterCondition]="deletedObjectsFilter"
					(objectIdsChange)="setObjectPropertyValue('PrerequisiteInstalls', $event)"
				/>
			</ada-container>
		}
		<!-- TODO: put this back once 9.1.965 has been in GA long enough that we can support production rollout of PrerequisiteInstallTree -->
		<!-- <ng-container *ngIf="('FollowupInstalls' | displayAuthoringProperty: editorClass:propertyConstructor.namespace) &&
				(currentPropertyObject?.FollowupInstalls || inheritedPropertyObject?.FollowupInstalls)?.length > 0"> -->
		<!-- FollowupInstalls -->
		@if ('FollowupInstalls' | displayAuthoringProperty: editorClass : propertyConstructor.namespace) {
			<ada-authoring-property-label
				#FollowupInstallsLabel
				content="Followup Installs"
				id="FollowupInstallsLabel"
				[inheriting]="currentPropertyObject?.FollowupInstalls | inheritPipe: inheritedPropertyObject?.FollowupInstalls"
				[isDisabled]="isDisabled"
				[isRequired]="'FollowupInstalls' | isRequiredProperty: editorClass : propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('FollowupInstalls')"
			/>
			<ada-container
				verticalSpacing="small"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<!-- @if (currentPropertyObject?.FollowupInstallTree || inheritedPropertyObject?.FollowupInstallTree) {
					<ada-alert
						type="warning"
						[isClosable]="false"
						[title]="'Ignored in favor of FollowupInstallTree'"
					/>
				} -->
				<ada-object-list
					#FollowupInstallsInput
					buttonText="Add Followup Install"
					data-testid="relationships-properties-follow-up-install-list"
					id="FollowupInstallsInput"
					[isDisabled]="isDisabled"
					[isReadOnly]="!!(currentPropertyObject?.FollowupInstallTree || inheritedPropertyObject?.FollowupInstallTree)"
					[javaClassName]="relationshipsClassName"
					[objectIds]="currentPropertyObject?.FollowupInstalls"
					[staticFilterCondition]="deletedObjectsFilter"
					(objectIdsChange)="setObjectPropertyValue('FollowupInstalls', $event)"
				/>
			</ada-container>
		}
		<!-- Supersedes -->
		@if ('Supersedes' | displayAuthoringProperty: editorClass : propertyConstructor.namespace) {
			<ada-authoring-property-label
				#SupersedesLabel
				content="Supersedes"
				id="SupersedesLabel"
				[isDisabled]="isDisabled"
				[isRequired]="'Supersedes' | isRequiredProperty: editorClass : propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
			/>
			<ada-object-list
				#SupersedesInput
				buttonText="Add Supersedes Installs"
				data-testid="relationships-properties-supersedes-install-list"
				id="SupersedesInput"
				[isDisabled]="isDisabled"
				[javaClassName]="relationshipsClassName"
				[objectIds]="currentPropertyObject?.Supersedes"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				[staticFilterCondition]="deletedObjectsFilter"
				(objectIdsChange)="setObjectPropertyValue('Supersedes', $event)"
			/>
		}
		<!-- SupersedesRemovalRequired -->
		@if ('SupersedesRemovalRequired' | displayAuthoringProperty: editorClass : propertyConstructor.namespace) {
			<ada-authoring-property-label
				#SupersedesRemovalRequiredLabel
				content="Supersedes Removal Required"
				id="SupersedesRemovalRequiredLabel"
				[isDisabled]="isDisabled"
				[isRequired]="'SupersedesRemovalRequired' | isRequiredProperty: editorClass : propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
			/>
			<ada-object-list
				#SupersedesRemovalRequiredInput
				buttonText="Add Supersedes Removal Required"
				data-testid="relationships-properties-supersedes-removal-required-list"
				id="SupersedesRemovalRequiredInput"
				[isDisabled]="isDisabled"
				[javaClassName]="relationshipsClassName"
				[objectIds]="currentPropertyObject?.SupersedesRemovalRequired"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				[staticFilterCondition]="deletedObjectsFilter"
				(objectIdsChange)="setObjectPropertyValue('SupersedesRemovalRequired', $event)"
			/>
		}
		<!-- SupersededBy -->
		@if ('SupersededBy' | displayAuthoringProperty: editorClass : propertyConstructor.namespace) {
			<ada-authoring-property-label
				#SupersededByLabel
				id="SupersededByRequiredLabel"
				[content]="'Superseded By'"
				[isDisabled]="isDisabled"
				[isRequired]="'SupersededBy' | isRequiredProperty: editorClass : propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
			/>
			<ada-object-list
				#SupersededByInput
				buttonText="Add Superseded By"
				data-testid="relationships-properties-supersedes-by-list"
				id="SupersededByInput"
				[isDisabled]="true"
				[javaClassName]="relationshipsClassName"
				[objectIds]="currentPropertyObject?.SupersededBy"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				[staticFilterCondition]="deletedObjectsFilter"
				(objectIdsChange)="setObjectPropertyValue('SupersededBy', $event)"
			/>
		}
	</ada-container>
</ada-card>
